export const BASE_Z_INDEX = {
  NAVBAR: 20,
  MAIN_SIDEBAR: 50,
  DROPDOWN: 100,
  MODAL: 1000,
}
